import { render } from "./footer.vue?vue&type=template&id=b0f28d44"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=b0f28d44&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__